
import { Component, OnInit } from '@angular/core';
import { FormBuilder, FormGroup, Validators } from '@angular/forms';
import { ActivatedRoute}  from '@angular/router';
//import { NgbActiveModal } from '@ng-bootstrap/ng-bootstrap';



// declare var tinymce: any;
@Component({
  selector: 'edit-n35',
  templateUrl: './edit-n35.component.html',
  styleUrls: ['./edit-n35.component.scss']
})
export class EditN35Component implements OnInit {
  dataId : any ;
  id: any;
  todoForm: FormGroup;
  createMode: boolean = true;
  //todo: TodoViewModel;

  constructor(private formBuilder: FormBuilder,private activated: ActivatedRoute) {
    console.log(this.activated.snapshot.paramMap.get('dataId'));
   }
  
  title = 'angulartinymc';
  ngOnInit() {
   
    let id = +this.activated.snapshot.paramMap.get('dataId');

    this.activated.data.subscribe  
    (params=>{this.dataId = params});
    console.log(this.dataId);

    
    this.todoForm = this.formBuilder.group({
      //title: ['', Validators.required],
      description: ['', Validators.required],
      done: false
    });
    
    /*tinymce.init(
    {
      
  
      language: 'sv',
      language_url: '/js/sv.js',
      plugins: 'myplugin',
      external_plugins: {
        'myplugin': '/js/myplugin/plugin.min.js'
      },
      selector: "#mymce1",
      
      // language: 'sv',
      // language_url: '/js/sv.js',
      // plugins: 'myplugin',
      // external_plugins: {
       // 'myplugin': '/js/myplugin/plugin.min.js'
      // },
      //menubar: 'file edit insert view format table tools help',
      // toolbar1 : "formatselect bold italic underline forecolor | bullist numlist | outdent indent | alignleft aligncenter alignright alignjustify | removeformat",
      // toolbar2 : "paste bullist link image justifyleft justifycenter justifyright justifyfull ",
      
    });*/
  }
}



